import { Avatar } from '@e2n/ui/v2';
import { Beruf } from '@/domain/mitarbeiter/features/rotationsplan/entities/Beruf';
import { Mitarbeiter as MitarbeiterType } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';
import { Location } from '@/domain/mitarbeiter/features/rotationsplan/components/Location';

export function Mitarbeiter({
  mitarbeiter,
  lehrjahr,
  beruf,
}: {
  mitarbeiter: MitarbeiterType;
  lehrjahr: string;
  beruf: Beruf;
}) {
  const initials =
    mitarbeiter.vorname[0].toUpperCase() +
    mitarbeiter.nachname[0].toUpperCase();

  return (
    <div className="sticky left-0 z-10 flex items-center gap-2 border-r border-solid border-separators-non-opaque p-1 bg-white">
      {mitarbeiter.imgUrl ? (
        <Avatar
          src={mitarbeiter.imgUrl}
          alt={mitarbeiter.vorname + ' ' + mitarbeiter.nachname}
          fallbackInitials={initials}
        />
      ) : (
        <Avatar type="initials" initials={initials} />
      )}
      <div className="hidden md:flex md:flex-col min-w-0 text-xs">
        <div className="text-labels-primary truncate">
          {mitarbeiter.vorname + ' ' + mitarbeiter.nachname}
        </div>
        <div className="text-labels-secondary">
          {lehrjahr + '⋅' + beruf.abkuerzung}
        </div>
        <Location
          className="text-labels-secondary"
          standort={mitarbeiter.standort}
        />
      </div>
    </div>
  );
}
